export function initContactFormModal() {
  document.addEventListener("wpcf7mailsent", function (event) {
    const cfModal = document.getElementById("mb-contactform-submit-modal");
    if (cfModal) {
      jQuery(cfModal).fadeIn(500).delay(2500).fadeOut(500);
    }
  });
}
